import { render, staticRenderFns } from "./Customer-Setting.vue?vue&type=template&id=5a60a002&scoped=true"
import script from "./Customer-Setting.vue?vue&type=script&lang=js"
export * from "./Customer-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60a002",
  null
  
)

export default component.exports